import React from 'react'
import PropTypes from 'prop-types'

import ServiceModal from './ServiceModal'

const WarningModal = props => (
	<ServiceModal
		type='warning'
		{...props} />
)

WarningModal.propTypes = {
	onClose: PropTypes.func.isRequired
}

WarningModal.defaultProps = {
	btnText: 'Ok'
}

export default WarningModal
